import { motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export const HeroPage = ({ onEnter }) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ x: '-100%', opacity: 0 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-0 w-full h-screen bg-[#050505]"
      data-testid="hero-page"
    >
      
      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-6">
        {/* Main Title - Clickable */}
        <motion.button
          onClick={onEnter}
          className="cursor-interact group text-center focus:outline-none"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          data-testid="hero-enter-button"
        >
          <motion.h1
            initial={{ y: 30, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="hero-title text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light tracking-wide leading-none"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            Waterline Group
          </motion.h1>
          
          {/* Description */}
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="text-zinc-400 text-sm sm:text-base md:text-lg font-light mt-4 sm:mt-6 max-w-xl text-center leading-relaxed px-4"
            style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}
          >
            A holding company investing in transformative AI ventures across healthcare, logistics, real estate, education, automotive, and creative industries.
          </motion.p>
        </motion.button>

        {/* Enter hint */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1, duration: 0.8 }}
          className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2"
        >
          <span className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500 pulse-hint">
            Click to Enter
          </span>
          <ChevronDown className="w-5 h-5 text-zinc-500 pulse-hint" />
        </motion.div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-8 right-8 text-xs font-mono text-zinc-600 tracking-wider">
        <span>EST. 2020</span>
      </div>
    </motion.div>
  );
};
